import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { subirMatrizPromocion, actualizarMatrizPromocion } from "../AccionesBackend";
import { subirArchivo, obtenerArchivos } from "../AccionesBackend";
import { Button } from "react-bootstrap";

const FormularioPromociones = ({
                                   promocionSeleccionada,
                                   onGuardar = () => {},
                                   onCancelar,
                                   seccionId,
                               }) => {
    const [formData, setFormData] = useState({
        seccion_id: seccionId || "",
        marca: "",
        nombre_oferta: "",
        no_ac: "",
        fecha_inicial: "",
        vigencia: "",
        canales_aplica: "",
        cobertura: "",
        pdfPromocion_id: null,
        portada_id: null,
    });

    const [nuevoArchivo, setNuevoArchivo] = useState(null); // Archivo PDF/Flyer
    const [nuevaPortada, setNuevaPortada] = useState(null); // Imagen de Portada
    const [pdfUrl, setPdfUrl] = useState(""); 
    const [portadaUrl, setPortadaUrl] = useState(""); 
    
    const fileInputRef = useRef(null);
    const portadaInputRef = useRef(null);

    useEffect(() => {
        const marcaPorSeccion = {
            23: "Izzi",
            24: "Sky",
            25: "Izzi móvil",
            26: "Wizz",
        };
        if (promocionSeleccionada) {
            setFormData({
                id: promocionSeleccionada.id,
                seccion_id: promocionSeleccionada.seccion_id,
                marca: promocionSeleccionada.marca || "",
                nombre_oferta: promocionSeleccionada.nombre_oferta || "",
                no_ac: promocionSeleccionada.no_ac || "",
                fecha_inicial: promocionSeleccionada.fecha_inicial || "",
                vigencia: promocionSeleccionada.vigencia || "",
                canales_aplica: promocionSeleccionada.canales_aplica || "",
                cobertura: promocionSeleccionada.cobertura || "",
                pdfPromocion_id: promocionSeleccionada.pdfPromocion_id || null,
                portada_id: promocionSeleccionada.portada_id || null,
            });
            if (promocionSeleccionada.pdfPromocion_id) {
                obtenerRutaArchivo(promocionSeleccionada.pdfPromocion_id, setPdfUrl);
            } else {
                setPdfUrl("");
            }
            if (promocionSeleccionada.portada_id) {
                obtenerRutaArchivo(promocionSeleccionada.portada_id, setPortadaUrl);
            } else {
                setPortadaUrl("");
            }
        } else {
            setFormData({
                seccion_id: seccionId,
                marca: marcaPorSeccion[seccionId] || "",
                nombre_oferta: "",
                no_ac: "",
                fecha_inicial: "",
                vigencia: "",
                canales_aplica: "",
                cobertura: "",
                pdfPromocion_id: null,
                portada_id: null,
            });
            setPdfUrl("");
            setPortadaUrl("");
        }
    }, [promocionSeleccionada, seccionId]);

    const obtenerRutaArchivo = async (archivoId, setter) => {
        try {
            const response = await obtenerArchivos({ archivoId });
            if (response.success && response.archivos.length > 0) {
                setter(response.archivos[0].ruta_archivo);
            } else {
                setter("");
            }
        } catch (err) {
            console.error(err);
            setter("");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubirArchivoGen = async (file, label = "archivo") => {
        try {
            const respArchivo = await subirArchivo({
                archivo: file,
                usuarioId: 1,
                seccionId: formData.seccion_id || seccionId,
            });
            if (!respArchivo.success) {
                Swal.fire({ icon: "error", title: "Error", text: `Error al subir el ${label}` });
                return null;
            }
            return respArchivo.archivo.id;
        } catch (error) {
            console.error(`Error en handleSubirPdf (${label}):`, error);
            Swal.fire({ icon: "error", title: "Error", text: `Error al subir el ${label}` });
            return null;
        }
    };

    const handleFileChange = (e) => setNuevoArchivo(e.target.files[0]);
    const handlePortadaChange = (e) => setNuevaPortada(e.target.files[0]);

    const handleVerUrl = (url) => {
        if (url) window.open(url, "_blank");
        else alert("No hay archivo para mostrar");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!formData.nombre_oferta || !formData.fecha_inicial || !formData.vigencia) {
                Swal.fire({ icon: "error", title: "Error", text: "Faltan datos requeridos." });
                return;
            }

            let dataToSend = { ...formData };

            // Subir Portada si hay una nueva
            if (nuevaPortada) {
                const portadaId = await handleSubirArchivoGen(nuevaPortada, "imagen de portada");
                if (!portadaId) return;
                dataToSend.portada_id = portadaId;
            }

            // Subir Archivo principal si hay uno nuevo
            if (nuevoArchivo) {
                const archivoId = await handleSubirArchivoGen(nuevoArchivo, "archivo de promoción");
                if (!archivoId) return;
                dataToSend.pdfPromocion_id = archivoId;
            }

            let response;
            if (dataToSend.id) {
                response = await actualizarMatrizPromocion(dataToSend.id, dataToSend);
            } else {
                response = await subirMatrizPromocion(dataToSend);
            }

            if (response.success) {
                Swal.fire({ icon: "success", title: "LISTO", text: "Se guardaron los cambios", timer: 2000, showConfirmButton: false })
                    .then(() => onGuardar());
            } else {
                Swal.fire({ icon: "error", title: "Error", text: response.mensaje });
            }
        } catch (error) {
            console.error("Error al enviar el formulario:", error);
            Swal.fire({ icon: "error", title: "Error", text: "Error al guardar la promoción." });
        }
    };

    return (
        <form onSubmit={handleSubmit} className="gestor-formulario grid-form">
            <div className="form-group">
                <label>Marca</label>
                <input type="text" name="marca" value={formData.marca} disabled />
            </div>
            <div className="form-group">
                <label>Nombre de la oferta</label>
                <input type="text" name="nombre_oferta" value={formData.nombre_oferta} onChange={handleChange} required />
            </div>
            <div className="form-group">
                <label>No. AC</label>
                <input type="text" name="no_ac" value={formData.no_ac} onChange={handleChange} required />
            </div>
            <div className="form-group">
                <label>Fecha Inicial</label>
                <input type="date" name="fecha_inicial" value={formData.fecha_inicial} onChange={handleChange} required />
            </div>
            <div className="form-group">
                <label>Vigencia</label>
                <input type="date" name="vigencia" value={formData.vigencia} onChange={handleChange} required />
            </div>
            <div className="form-group">
                <label>Canales que aplica</label>
                <input type="text" name="canales_aplica" value={formData.canales_aplica} onChange={handleChange} required />
            </div>
            <div className="form-group">
                <label>Cobertura</label>
                <input type="text" name="cobertura" value={formData.cobertura} onChange={handleChange} required />
            </div>

            {/* IMAGEN DE PORTADA */}
            <div className="form-group">
                <label>Imagen de Portada (Miniatura)</label>
                {portadaUrl ? (
                    <div>
                        <img src={portadaUrl} alt="Portada" style={{ width: "50px", height: "50px", objectFit: "cover", marginRight: "10px", borderRadius: "4px" }} />
                        <Button variant="secondary" size="sm" onClick={() => portadaInputRef.current.click()}>Cambiar Portada</Button>
                    </div>
                ) : (
                    <Button variant="secondary" size="sm" onClick={() => portadaInputRef.current.click()}>Subir Portada</Button>
                )}
                {nuevaPortada && <span className="ms-2" style={{fontSize: "0.8rem"}}>{nuevaPortada.name}</span>}
                <input type="file" style={{ display: "none" }} ref={portadaInputRef} onChange={handlePortadaChange} accept="image/*" />
            </div>

            {/* ARCHIVO PRINCIPAL */}
            <div className="form-group">
                <label>Archivo Detalle (PDF o Imagen)</label>
                {pdfUrl ? (
                    <div>
                        <Button variant="link" size="sm" onClick={() => handleVerUrl(pdfUrl)}>Ver Archivo Actual</Button>
                        <Button variant="secondary" size="sm" onClick={() => fileInputRef.current.click()} className="ms-2">Actualizar Archivo</Button>
                    </div>
                ) : (
                    <Button variant="secondary" size="sm" onClick={() => fileInputRef.current.click()}>Subir Archivo</Button>
                )}
                {nuevoArchivo && <span className="ms-2" style={{fontSize: "0.8rem"}}>{nuevoArchivo.name}</span>}
                <input type="file" style={{ display: "none" }} ref={fileInputRef} onChange={handleFileChange} accept="application/pdf,image/*" />
            </div>

            <div className="form-buttons">
                <button type="submit" className="btn-save">Guardar</button>
                <button type="button" className="btn-cancel" onClick={onCancelar}>Cancelar</button>
            </div>
        </form>
    );
};

export default FormularioPromociones;
